import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import SettingsTab from "components/__new/settings/tab";
import { toast } from 'react-toastify';
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import validate from "utils/validate";
import PageContent from "components/__new/common/PageContent";
import Maybe from "components/__new/common/Maybe";
import { ButtonLoader, SelectInput } from "components/__new/common/form";
// import numberOrdinalSuffix from "utils/numberOrdinalSuffix";
import ReactToolTip from "react-tooltip";
// import { ReactComponent as IconCheckboxBorder } from "assets/images/icons/project-icons/checkbox-border.svg";
import { ReactComponent as IconInformationOutline } from "assets/images/icons/project-icons/information-outline.svg";
import SlideToggle from "components/__new/common/form/SlideToggle";
import CurrencyFormat from "utils/currencyFormat";
import useEmployerProducts from 'hooks/useEmployerProducts';
import useLoginInfo from "hooks/useLoginInfo";
import * as infoActions from "store/entities/settingsInfo/action";


const Preferences = () => {
    const dispatch = useDispatch();
    const { userInfo } = useLoginInfo();
    const { isOnDemandUser } = useEmployerProducts();
    const { companyInfoLoading, companyInfo, companyFeesLoading, companyFees,
        updatePolicyInfoLoading, updatePolicyInfoSuccess, updateLegalInfoLoading, updateLegalInfoSuccess } = useSelector((s) => s.entities.settingsInfo);


    const [editPreferenceOnDemand, setEditPreferenceOnDemand] = useState(false);
    const [editPreferencePayroll, setEditPreferencePayroll] = useState(false);
    const [withdrawalPercentOptions, setWithdrawalPercentOptions] = useState([50]);
    const [form, setForm] = useState({
        payrollCutOff: "",
        withdrawalPercent: "",
        paymentFee: "",
        autoWithdrawals: "",

        // payrollType: "",
        prorateSalary: "",
        prorateSalarySettings: "",

        address: "",
        companyName: "",
        estimatedEmployees: "",
        estimatedSalary: "",
        invoiceEmail: "",
        rcNumber: "",
        tinNumber: "",
    })


    // const updatePayrollType = (value) => {
    //     if (editPreferencePayroll === true){
    //         setForm({...form, payrollType: value})
    //     }
    // }


    const submitForm = async e => {
        e.preventDefault();
        if (editPreferenceOnDemand === true || editPreferencePayroll === true){
            
            if(isOnDemandUser === false) {
                const validateForm = {...form};
                delete validateForm["withdrawalPercent"];
                delete validateForm["tinNumber"];
                delete validateForm["invoiceEmail"];
                delete validateForm["payrollCutOff"];
                
                const errors = validate(validateForm);
                if (errors){
                    for (var err in errors) {
                        toast.error(errors[err]);
                    };
                    return;
                } else {
                    dispatch(infoActions.editPolicyInfo(validateForm));
                }
            } else {
                const errors = validate(form);
                if (errors){
                    for (var x in errors) {
                        toast.error(errors[x]);
                    };
                    return;
                }
                else{
                    const paramsPolicyInfo = {
                        payrollCutOff: form.payrollCutOff,
                        withdrawalPercent: form.withdrawalPercent,
                        autoWithdrawals: form.autoWithdrawals,
                        paymentFee: form.paymentFee,
                    }
                    dispatch(infoActions.editPolicyInfo(paramsPolicyInfo));

                    // if (editPreferencePayroll === true){
                    //     const paramsCompanySettings = {
                    //         payrollType: form.payrollType,
                            
                    //         address: form.address,
                    //         companyName: form.companyName,
                    //         estimatedEmployees: form.estimatedEmployees,
                    //         estimatedSalary: form.estimatedSalary,
                    //         invoiceEmail: form.invoiceEmail,
                    //         rcNumber: form.rcNumber,
                    //         tinNumber: form.tinNumber,
                    //     }
                    //     dispatch(infoActions.editLegalInfo(paramsCompanySettings));
                    // }
                }
            }
        }
    }


    const populateWithdrawalPercentOptions = (value) => {
        const newOptions = [...withdrawalPercentOptions];
        if (value !== ""){
            if (!(newOptions.includes(value))){
                newOptions.push(value);
            }
        }
        newOptions.sort();
        setWithdrawalPercentOptions(newOptions);
    }


    const cancelEditPreferenceOnDemand = () => {
        setForm({
            ...form,
            payrollCutOff: companyInfo?.company?.payrollCutOff ?? "",
            withdrawalPercent: companyInfo?.company?.withdrawalPercent ?? "",
            paymentFee: companyInfo?.company?.paymentFee ?? "",
        })
        setEditPreferenceOnDemand(false);
    }


    const cancelEditPreferencePayroll = () => {
        setForm({
            ...form,
            prorateSalary: companyInfo?.company?.prorateSalary ?? "",
            prorateSalarySettings: companyInfo?.company?.prorateSalarySettings ?? "",
        })
        setEditPreferencePayroll(false);
    }


    useEffect(() => {
        if(isOnDemandUser) {
            dispatch(infoActions.getInfo(userInfo?.company?.selectedCompanyId));
            dispatch(infoActions.getCompanyFees());
        }
        // eslint-disable-next-line
    }, [])


    useEffect(() => {
        if (updatePolicyInfoSuccess === true && updateLegalInfoLoading === false){
            setEditPreferenceOnDemand(false);
            setEditPreferencePayroll(false);
            if (companyInfoLoading === false){
                dispatch(infoActions.getInfo(userInfo?.company?.selectedCompanyId));
            }
        }
        // eslint-disable-next-line
    }, [updatePolicyInfoSuccess]);


    useEffect(() => {
        if (updateLegalInfoSuccess === true && updatePolicyInfoLoading === false){
            setEditPreferencePayroll(false);
            if (companyInfoLoading === false){
                dispatch(infoActions.getInfo(userInfo?.company?.selectedCompanyId));
            }
        }
        // eslint-disable-next-line
    }, [updateLegalInfoSuccess]);


    useEffect(() => {
        if (companyInfo?.status === "success"){
            const newForm = {
                address: companyInfo?.company?.address ?? "",
                companyName: companyInfo?.company?.companyName ?? "",
                estimatedEmployees: companyInfo?.company?.estimatedEmployees?.toString() ?? "",
                estimatedSalary: companyInfo?.company?.estimatedSalary?.toString() ?? "",
                invoiceEmail: companyInfo?.company?.invoiceEmail ?? "",
                rcNumber: companyInfo?.company?.rcNumber ?? "",
                tinNumber: companyInfo?.company?.tinNumber ?? "",
                
                payrollCutOff: companyInfo?.company?.payrollCutOff ?? "",
                withdrawalPercent: companyInfo?.company?.withdrawalPercent ?? "",
                autoWithdrawals: companyInfo?.company?.autoWithdrawals ?? "",
                paymentFee: companyInfo?.company?.paymentFee ?? "",
                // payrollType: companyInfo?.company?.payrollType ?? "",

                prorateSalary: companyInfo?.company?.prorateSalary || false,
                prorateSalarySettings: companyInfo?.company?.prorateSalarySettings ?? "",
            }
            setForm({...form, ...newForm});
            populateWithdrawalPercentOptions(newForm.withdrawalPercent);
        }
        // eslint-disable-next-line
    }, [companyInfo]);
    

    return ( 
        <div>


            <DynamicHeadTag
                headerText="Preferences | Settings"
                headerDescription="Customize your account preferences, including account information, security and privacy settings, notifications, and other account-related options."
            />


            <div className="lg:flex">
                <div className="w-full lg:w-1/2">
                    <div className="page-title">
                        Settings
                    </div>
                </div>
                <div className="w-full lg:w-1/2 flex mt-4 lg:mt-0 lg:justify-end space-x-3"></div>
            </div>


            <div className="mt-6 border-b">
                <SettingsTab />
            </div>


            <PageContent
                loading={companyInfoLoading}
                data={companyInfo}
                loadingText="Loading preferences..."
                emptyText="Company preferences not found"
                errorText="Unable to fetch company preferences"
                classes="mt-6 box"
            />


            <Maybe condition={companyInfoLoading === false && companyInfo?.status === "success"}>
                <div>
                    <form onSubmit={submitForm}>
                        
                        <Maybe condition={isOnDemandUser}>
                            <div className="mt-6 box">
                                <div className="max-w-3xl">
                                    <div className="flex justify-between">
                                        <div className="font-bold">
                                            On-demand Pay
                                        </div>
                                        <div>
                                            <Maybe condition={userInfo.employer.userType === 'employer'}>
                                            <Maybe condition={editPreferenceOnDemand === false}>
                                                <button type="button" onClick={() => {setEditPreferenceOnDemand(true); cancelEditPreferencePayroll()}} className="text-ep-primary underline">
                                                    Edit Information
                                                </button>
                                            </Maybe>
                                            </Maybe>
                                        </div>
                                    </div>

                                    <div className="mt-4 border border-gray-200 rounded-md">
                                        <div className="p-4">
                                            <div className="max-w-xs">
                                                <SelectInput label="Employee Access %" className="form-input" required={true} value={form.withdrawalPercent} onChange={(e) => setForm({...form, withdrawalPercent: e.target.value})} disabled={!editPreferenceOnDemand}>
                                                    <option value="">Select Option</option>
                                                    {withdrawalPercentOptions.map(percent =>
                                                        <option key={percent} value={percent}>{percent}%</option>
                                                    )}
                                                </SelectInput>
                                            </div>
                                        </div>
                                        <div className="p-4 -mt-4 text-fade text-xs border-t">
                                            Employee Access refers to the percentage of the salary you want the employees to access to in the course of the month.
                                        </div>
                                    </div>

                                    <div className="mt-4 border border-gray-200 rounded-md">
                                        <div className="p-4">
                                            <div className="max-w-xs">
                                                <SelectInput label="Fee payment" className="form-input" required={true} value={form.paymentFee} onChange={(e) => setForm({...form, paymentFee: e.target.value})} disabled={!editPreferenceOnDemand}>
                                                    <option value="">Select Option</option>
                                                    <option value="employee">By Employee</option>
                                                    <option value="employer">By Business</option>
                                                    <option value="shared">Shared</option>
                                                </SelectInput>
                                            </div>
                                        </div>
                                        <div className="p-4 -mt-4 text-fade text-xs border-t">
                                            kindly select who pay's the earnipay's fee
                                        </div>
                                    </div>

                                    <div className="mt-4 border border-gray-200 rounded-md">
                                        <div className="p-4">
                                            <div>
                                                Fee Structure
                                            </div>
                                            <div className="my-4">
                                                <PageContent
                                                    loading={companyFeesLoading}
                                                    data={companyFees}
                                                    loadingText="Fetching company fees"
                                                    emptyText="Company fees not found"
                                                    errorText="Unable to fetch company fees"
                                                />

                                                <Maybe condition={companyFeesLoading === false && companyFees?.status === "success"}>
                                                    {companyFees?.data?.map(companyFee => 
                                                        <div key={companyFee._id} className="flex space-x-2">
                                                            <div>
                                                                {CurrencyFormat(companyFee.minAmount)} - {CurrencyFormat(companyFee.maxAmount)}
                                                            </div>
                                                            <div>
                                                                at
                                                            </div>
                                                            <div>
                                                                <Maybe condition={companyFee.type === "fixed"}>
                                                                    {CurrencyFormat(companyFee.fee)}
                                                                </Maybe>
                                                                <Maybe condition={companyFee.type === "percentage"}>
                                                                    {companyFee.fee}%
                                                                </Maybe>
                                                            </div>
                                                        </div>
                                                    )}
                                                </Maybe>
                                            </div>
                                        </div>
                                        <div className="p-4 -mt-4 text-fade text-xs border-t">
                                            The Fee Structure refers to the list to payment bands and their respective fees for employees.
                                        </div>
                                    </div>

                                    <Maybe condition={editPreferenceOnDemand === true}>
                                        <div className="mt-6 flex space-x-4">
                                            <ButtonLoader type="submit" loading={(updatePolicyInfoLoading) && editPreferenceOnDemand} className="btn btn-ep-primary">
                                                Update Preference
                                            </ButtonLoader>
                                            <button type="button" onClick={cancelEditPreferenceOnDemand} className="btn btn-transparent-primary">
                                                Cancel
                                            </button>
                                        </div>
                                    </Maybe>
                                </div>
                            </div>
                        </Maybe>

                        <div className="mt-10 box">
                            <div className="max-w-3xl">
                                <div className="flex justify-between">
                                    <div className="font-bold">
                                        Payroll
                                    </div>
                                    <div>
                                        <Maybe condition={userInfo.employer.userType === 'employer'}>
                                        <Maybe condition={editPreferencePayroll === false}>
                                            <button type="button" onClick={() => {setEditPreferencePayroll(true); cancelEditPreferenceOnDemand()}} className="text-ep-primary underline">
                                                Edit Information
                                            </button>
                                        </Maybe>
                                        </Maybe>
                                    </div>
                                </div>


                                <div className="mt-8 border border-gray-200 rounded-md">
                                    <div className="p-4 flex space-x-4 justify-between">
                                        <div className="font-medium flex items-center">
                                            Salary Proration
                                            <IconInformationOutline className="svg-stroke-black w-4 ml-2" data-tip data-for="salary-proration" />
                                            <ReactToolTip id="salary-proration" className="tooptip-size max-w-[250px]">
                                                This would only affect employees that have their resumption date included in their employee details
                                            </ReactToolTip>
                                        </div>
                                        <div className="flex space-x-4 items-center">
                                            <div className="text-sm text-ep-primary">
                                                <Maybe condition={form.prorateSalary === true}>
                                                    <span className="text-sm text-ep-primary">Activated</span>
                                                </Maybe>
                                                <Maybe condition={form.prorateSalary !== true}>
                                                    <span className="text-sm text-gray-400">Deactivated</span>
                                                </Maybe>
                                            </div>
                                            <SlideToggle
                                                active={form.prorateSalary}
                                                disabled={!editPreferencePayroll}
                                                onChange={(e) => setForm({...form, prorateSalary: e})}
                                            />
                                        </div>
                                    </div>
                                    <div className="p-4 border-t border-gray-200 lg:flex lg:space-x-6 lg:items-center lg:justify-between">
                                        <div className="text-[#667085] text-sm">
                                            The Salary Proration refers to the amount an employee should be paid in relation to the exact amount the employee have worked.
                                        </div>
                                        <div className="mt-3 lg:mt-0 w-full max-w-[18rem]">
                                            <SelectInput label="" classes="mb-0" value={form.prorateSalarySettings} onChange={(e) => setForm({...form, prorateSalarySettings: e.target.value})} disabled={!editPreferencePayroll}>
                                                <option value="">Select</option>
                                                <option value="weekdayOnly">Weekdays only</option>
                                                <option value="weekendsOnly">Weekends only</option>
                                                <option value="weekendsInclusive">Weekends inclusive</option>
                                            </SelectInput>
                                        </div>
                                    </div>
                                </div>

                                
                                {/* 
                                <div className="pt-4 border-t border-gray-200">
                                    <div>
                                        Choose your preferred Payroll Style 
                                    </div>
                                    <div className="mt-4 space-y-4">
                                        <div onClick={() => updatePayrollType("gross")} className={`form-choose ${form.payrollType === "gross" && "form-choose-active"}`}>
                                            <div>
                                                <div>
                                                    Use Gross Salary For Payroll
                                                </div>
                                                <div className="form-choose-checkbox">
                                                    <div className="form-choose-checkbox-empty"></div>
                                                    <IconCheckboxBorder className="w-full h-full form-choose-checkbox-icon" />
                                                </div>
                                            </div>
                                            <div className="p-4 text-sm text-fade">
                                                This includes regular pay, bonuses, commissions, and overtime pay. Gross salary is used to calculate payroll deductions like income tax, Pension, and ITF. Once the deductions are calculated, the net pay or take-home pay of the employee is determined.
                                            </div>
                                        </div>
                                        <div onClick={() => updatePayrollType("net")} className={`form-choose ${form.payrollType === "net" && "form-choose-active"}`}>
                                            <div>
                                                <div>
                                                    Use Net Salary for Payroll
                                                </div>
                                                <div className="form-choose-checkbox">
                                                    <div className="form-choose-checkbox-empty"></div>
                                                    <IconCheckboxBorder className="w-full h-full form-choose-checkbox-icon" />
                                                </div>
                                            </div>
                                            <div className="p-4 text-sm text-fade">
                                                Net salary is the salary an employee receives after all applicable deductions, taxes, and withholdings have been subtracted from their gross salary. It is the actual amount of money that the employee takes home and can use for expenses.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                */}
                                 

                                <Maybe condition={editPreferencePayroll === true}>
                                    <div className="mt-6 flex space-x-4">
                                        <ButtonLoader type="submit" loading={(updatePolicyInfoLoading || updateLegalInfoLoading) && editPreferencePayroll} className="btn btn-ep-primary">
                                            Update Preference
                                        </ButtonLoader>
                                        <button type="button" onClick={cancelEditPreferencePayroll} className="btn btn-transparent-primary">
                                            Cancel
                                        </button>
                                    </div>
                                </Maybe>
                            </div>
                        </div>

                    </form>
                </div>
            </Maybe>

        </div>
    )
}


export default Preferences;